<template>
  <div>
    <!-- 标题 -->
    <img src="../../static/img/ejymjpg.jpg" alt="" width="100%" id="ejimg1">
    <img src="../../static/img/ejmljpg.jpg" alt="" id="ejimg2">

    <div class="url2box">
      <div class="urlbox" >
        <div class="urlName" v-for="(item,index) in urlList" @click="openUrl(item,index)">{{item.menuName}}</div>
      </div>
    </div>
    <div class="btcss">
      <div class="tabbox">
        <div  :class="{'active':active_btn1==index}" v-for="(item,index) in xmlist" @click="newsList1(index,item)">
          <el-tooltip class="item" effect="dark" :content="item.menuName" placement="top-start">
            <span>{{item.menuName}}</span>
          </el-tooltip>
        </div>
        <div class="dqwz">首页 > {{titleName1}} > {{titleName2}}</div>
      </div>
    </div>

    <!--    <div class="tabbox" v-if="this.show">
          <div  :class="{'active':active_btn2==index}"  v-for="(item,index) in levelist" @click="newsList2(index,item)">{{item.menuName}}</div>
        </div>-->
    <div v-if="wzshow" style="width:90%;min-height: 500px;cursor: pointer">
      <img src="../../static/img/yzxckdk.jpg" v-if="!zwsj" @click="openPdf" alt="" class="yzxckdk" style="padding-left: 45%;padding-top: 10%;">
      <img src="../../static/img/zwsj.png" v-if="zwsj"  @click="openPdf" alt="" class="yzxckdk" style="padding-left: 45%;padding-top: 10%;">
    </div>
    <div class="content" >
      <div class="sanjimulu" v-if="levelist && levelist.length > 0">
        <el-tree :data="levelist" :props="defaultProps"  @node-click="handleNodeClick ">
            <span class="custom-tree-node" slot-scope="{ node, data }" >
               <el-tooltip class="item" popper-class="btnitem" effect="dark" :content="node.label" placement="top-start">
                 <span>{{ node.label }}</span>
               </el-tooltip>
            </span>
        </el-tree>
      </div>
      <div style="margin: 0px auto;" v-html="ejDetail">
      </div>
    </div>
    <!--    <div class="content" v-if="detailsShow">
          <div v-html="ejDetail"></div>
        </div>-->

  </div>
</template>
<script>
let api = 'https://www.slfangshuijiao.com/api';
let deptId = 110
export default {
  name: 'Ejml',
  data() {
    return {
      urlList:[],
      newsList:[],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      active_btn1:0,
      active_btn2:0,
      xmlist: [],
      levelist: [],
      titleName1: '',
      titleName2: '',
      ejDetail: '',
      visible: false,
      show: false,
      api,
      activeIndex: '1',
      activeIndex2: '1',
      form: {},
      rules: {},
      dataTime: '',
      imgList: [],
      columnData: [],
      outsideList: [],
      sjtitle:'',
      ruleForm: [],
      fileList: [],
      detailsShow:true,
      wzshow:false,
      zwxx:false,
      urlIndex:'',
      titleList:[
        {name:'走进神力'},
        {name:'郑重声明'},
        {name:'齐全的荣誉证照'},
        {name:'完善的资质证书'},
        {name:'企业规划优势'},
        {name:'招商优惠政策'},
      ],
    }
  },
  created() {
    this.titleName1 = this.$route.query.name
    this.target = this.$route.query.target
    // console.log(123, this.target);
    this.urlIndex= this.$route.query.index
    // console.log('下标--',this.urlIndex);
    if (this.urlIndex){
      this.active_btn1 = this.urlIndex
    }
    // console.log(11, this.dataTime, new Date().getMonth())
  },
  mounted() {
    this.newList()
    this.lbList('',this.urlIndex)
  },
  methods: {
    //新闻列表
    newList() {
      let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.newsList = that.handleTree(res.data.data, 'menuId', 'parentId')
            console.log(6666,that.newsList);
            //建筑用胶粘剂产品世界数据
            that.newsList.forEach(item=>{
              if (item.menuName == '产品世界'){
                that.listData1 = item.children[0].children
                that.listData2 = item.children[1].children
                that.menuId = item.menuId
                that.name1 = item.children[0].menuName
                that.name2 = item.children[1].menuName
              }
            })
            var newArr1 = []
            // var newArr2 = []
            that.newsList.forEach(item => {
              if (item.visible == 1){
                newArr1.push(item)
              }
            })
            // that.newsList1 = newArr1
            console.log(111122222222,newArr1)

            if (newArr1) {
              //获取轮播图下方导航栏
              newArr1.forEach((item,index)=>{
                if (item.menuId == 1491 || item.menuName == '轮播图下方导航栏'){
                  that.urlList = item.children
                  return
                }
              })
            }
            console.log('shuju',newArr1);
          }
        } else {
          that.$message.error(res.message);
        }
      })
      /*let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.newsList = that.handleTree(res.data.data, 'menuId', 'parentId')
            var newArr1 = []
            // var newArr2 = []
            that.newsList.forEach(item => {
              if (item.menuName == '新闻报导') {
                newArr1.push(item)
              } else if (item.menuName == '聘兼职业务员') {
                newArr1.push(item)
              } else if (item.menuName == '产品世界') {
                newArr1.push(item)
                that.menuId = item.menuId
                that.name1 = item.children[0].menuName
                that.name2 = item.children[1].menuName
                console.log('name1----',that.name1,that.name2);
              } else if (item.menuName == '国家部门对防水推广') {
                newArr1.push(item)
              } else if (item.menuName == '国家荣誉证书') {
                newArr1.push(item)
              } else if (item.menuName == '中央领导关注') {
                newArr1.push(item)
              }
            })
            that.newsList1 = newArr1
            console.log(1111,newArr1)
            // that.newsList2 = newArr2
            if (newArr1) {
              // that.newsTitle = newArr1[0].children
              that.oneNewTitle = newArr1[0].children[0]

              newArr1[0].children.forEach((item,index)=>{
                // if (index > 0 && index<5){
                  item.createTime = item.createTime.slice(0,10)
                  that.newsTitle.push(item)
                // }
              })
            }
            console.log('shuju',newArr1[0].children,that.newsTitle);
            console.log('一条',that.oneNewTitle);
          }
        } else {
          that.$message.error(res.message);
        }
      })*/
    },
    handleNodeClick(data) {
      this.sjtitle = data.menuName
      if (data.menuType == 'F'){
        this.ejDetail = data.perms;
      }
    },
    openPdf(){
      console.log(66,this.fileList)
      if(this.fileList[0].target !=''){
        window.open(this.api  + this.fileList[0].target)
      }
    },
    newsList1(index,item){
      this.active_btn1 = index
      this.titleName2 = item.menuName
      console.log('mc',item.menuName);
      this.active_btn2 = 0
      this.ejDetail = this.xmlist[this.active_btn1].perms
      //之前是menuId你看数据
      this.lbList(item.parentId,this.active_btn1)
      console.log("index",this.active_btn1)
      console.log("数据",item.menuId,this.active_btn1)
      this.wzshow = false
      this.detailsShow = true
      if(item.menuType == 'C'&&item.target !=''){
        window.open(this.api  + item.target)
      }
    },
    newsList2(index,item){
      let that = this;
      that.active_btn2 = index
      // console.log('数据---',that.levelist,that.active_btn2);


      // this.levesList(item.menuId,index)
      that.ejDetail = that.levelist[that.active_btn2].perms
      // console.log('id====',item.menuId,index);
    },
    //获取三级列表
    levesList(id) {
      let that = this;
      that.$axios.post(api + '/site/columnList?deptId=' + deptId ,{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function(res) {
        if (res.data.code == '0') {
          // console.log('列表11',res.data.data)
          // that.levelist = res.data.data
          // that.ejDetail = res.data.data[0].perms
          if (res.data.data) {
            var arr = []
            res.data.data.forEach(item => {
              if (item.visible == 0) {
                arr.push(item)
              }
            })
            let list = that.handleTree(arr, 'menuId', 'parentId')
            console.log('树',list,that.titleName2);
            if (list){
              list.forEach(item=>{
                //判断第一级
                if (item.menuName == that.titleName1){
                  //判断第二级
                  item.children.forEach(item =>{
                    if (item.menuName == that.titleName2){
                      that.levelist = item.children
                    //
                     if(item.children){
                       item.children.forEach(item =>{
                         if (item.menuName == that.titleName2){
                           that.levelist = item.children}

                       })
                     }
                    }
                  })
                  // that.levelist = item
                }
              })
            }
            console.log(111,that.levelist);
            // that.ejDetail = that.levelist[0].perms
            // console.log(that.levelist[0].children[0].menuName)
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },
    // 栏目详情(没用到)
    menuList(id, name) {
      let that = this;
      id = this.$route.query.id
      that.$axios.post(api + '/site/columnDetail' , {
        columnId: id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          // console.log(res.data.data.length)
          if (res.data.data.length > 0) {
            let type = res.data.data[0].menuType
            // ?
            if (type === 'M') {
              window.location = "/#/ejml2?id=" + id + '&name=' + encodeURI(name)
            } else if (type === 'D') {
              window.location = "/#/cpDetails?id=" + id + '&name=' + encodeURI(name)
            } else if (type === 'F') {
              window.location = "/#/xiangqing?id=" + id + '&name=' + encodeURI(name)
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },
    openUrl(item,index) {
      index = 0
      if (item.menuName != "首页") {
        if (item.menuName === "产品世界") {
          //menuId 获取当前点击的第一章-第一节-第一个的menuId
          window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName) + '&index=' + index+ '&titName=' + item.children[0].menuName + '&menuId=' + item.children[0].children[0].children[0].menuId;

          // console.log(item,item.children[0].children[0].children[0].menuId)
          // window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName)+ '&menuId=' + item.menuId;
        } else {
          window.location = '/#/ejml?id=' + item.menuId + '&name=' + encodeURI(item.menuName);
        }
        window.location.reload();
      } else {
        window.location = '/#/';
        window.location.reload();
      }
    },
    //获取列表
    lbList(ids,index,item) {
      let that = this;
      var id
      if (ids){
        id = ids
      }else {
        id = this.$route.query.id
      }
      // id = this.$route.query.id

      // console.log('id2222',id);

      that.$axios.post(api + '/site/columnDetail' , {
        columnId: id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          // console.log("idsaaa",ids)
          if (!ids){
            that.xmlist = res.data.data
            console.log('数据',that.xmlist);
          }
          // that.xmlist = res.data.data
          //c新窗口打开时获取值
          that.fileList = res.data.data
          if (res.data.data){
            console.log('index',index);
            if (index == undefined){
              that.ejDetail = res.data.data[0].perms
              that.titleName2 = res.data.data[0].menuName
              console.log('下标',index,that.ejDetail,res.data.data);
            }else {
              console.log('三级数据',res.data.data);
              that.ejDetail = res.data.data[index].perms
              that.titleName2 = res.data.data[index].menuName
            }
            that.show = false;
            if (that.xmlist[that.active_btn1].menuType === 'M'){
              that.show = true
              that.levesList(that.xmlist[that.active_btn1].menuId)
              console.log('xmlist',that.xmlist[that.active_btn1]);

            }else{
              that.levelist = []
            }
            if (that.xmlist[that.active_btn1].menuType === 'C'){
              that.wzshow = true
              that.detailsShow = false
              if(that.fileList[0].target !=''){
                that.zwsj=false;
              }else {
                that.zwsj=true;
              }
            }else {
              that.wzshow = false
              that.detailsShow = true
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },
    // openDetails(item) {
    //   // window.open("/#/ejml2")
    //   console.log(222, item)
    //   if (item.menuType === 'M') {
    //     window.location = "/#/ejml2?id=" + item.menuId + '&name=' + encodeURI(item.menuName)
    //   } else if (item.menuType === 'D') {
    //     window.location = "/#/cplist?id=" + item.menuId + '&name=' + encodeURI(item.menuName)
    //   } else if (item.menuType === 'F') {
    //     window.location = "/#/xiangqing?id=" + item.menuId + '&name=' + encodeURI(item.menuName)
    //   }
    // },
    //获取url
    GetQueryString(str) {
      var reg = new RegExp("(^|&)" + str + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },

  }
}
</script>
<style>
.urlName{
  font-size: 16px;
  border-radius: 25px;
  background:linear-gradient(to right,#EE9AE5,#C71BFF,#7030A0);
  min-width: 110px;
  margin: 14px auto;
  color: #fff;
  padding: 10px;
  float: left;
  margin-right: 10px;
  text-align: center;
  cursor: pointer;
}
.urlbox{
  float: left;
}
.url2box{
  padding: 25px;
  width: 60%;
  margin: auto;
  overflow: auto;
}
#ejimg2{
  display: none;
}
/*屏蔽箭头*/
.el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after{
  display: none;
}
.el-tooltip__popper.is-dark {
  background: #eaeefb;
  color: #303133;
}
.custom-tree-node{
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sanjimulu{
  margin-right: 30px;
  margin-bottom: 30px;
  padding-right: 30px;
  border-right: 1px solid rgb(110, 110, 110);
  max-width: 20%;
}
.el-tree-node__label{
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-tree__empty-text {
  display: none;
}
.content{
  display: flex;
  width: 90%;
  margin: 30px auto 0 auto;
  min-height: 800px;
}

.yzxckdk{
  padding-left: 45%;
  padding-top: 10%;
}
/*头部*/
.dqwz{
  color: rgba(110,110,110,1);
  font-size: 14px;
  float: right;
  height: 30px;
  padding: 0 65px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.btcss{
  border-bottom:  rgba(110,110,110,1) solid 1px;
  margin-bottom: 30px;
  overflow: hidden;
  line-height: 37px;
}

.active {
  color: red;
  font-weight: 600;
  border-bottom: #ffde00 solid 3px;
}
.tabbox div{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  min-width: 80px;
  cursor: pointer;
  padding: 5px 2px;
  margin-left: 20px;
}
.tabbox{
  display: flex;
  width: 93%;
  padding: 0px 15px 0 15px;
  justify-content: space-between;
  margin-left: 45px;
  float: left;
  flex-wrap: wrap;
  /*justify-content:space-around;*/
  /*font-weight: bold;*/
}
.flexbox {
  display: flex;
  font-size: 18px;
  padding: 10px;
  cursor: pointer;
}

.flexbox:hover {
  color: red;
}

.sjimg {
  background-color: rgb(0, 160, 233);
  -webkit-mask: url(./../../static/img/erjijiantou.svg) center center / contain no-repeat;
  width: 50px;
}

.centerbox {
  overflow: auto;
  width: 50%;
  margin: auto;
  padding: 15px;
  height: 50%;
}

body,
html {
  height: 100%;
  margin: 0;
}

#app {
  height: 100%;
  width: 100%;
  /*background-image: url(../../static/img/939939bfb61178f5b4706ec7ed06302.jpg);*/
  background-size: 100% 100%;
}

.bt {
  background-image: url(../../static/img/3e335a61c60a1f37dbe724dd45f0090f_10121_1465_75.png);
  color: #FFFFFF;
  width: 100%;
  text-align: center;
  align-content: center;
  margin: 0;
}


.el-dialog__wrapper {
  overflow: hidden;
}

.zxbox .el-dialog {
  left: 22% !important;
  margin-top: auto !important;
}

.zxbox .el-dialog__header {
  background-color: #009FED;
  padding: 0px;
}

.zxbox .el-dialog__title {
  color: #fff;
}

.zxbox .dialog-header-title {
  display: flex;
  border-radius: 10px;
}

.zxbox .el-dialog__close {
  color: #fff;
}

.zxbox {
  top: 35%;
}

.zxname {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 40px;
  padding: 0 5px;
  line-height: 50px;
}

.el-form-item__content {
  text-align: center;
  padding: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}

.el-popover,
.popper__arrow::after {
  padding: 0px;
  border-radius: 10px;
  background-color: rgb(0, 160, 233);
  border: 1px solid rgb(0, 160, 233)
}

.zxcha {
  line-height: 40px;
  font-size: 16px;
}

.zxhead {
  display: flex;
  color: #fff;
  background-color: rgb(0, 160, 233);
  border-radius: 10px;
}
.el-tree-node {
  outline: 0;
  overflow: hidden;
}
@media screen and (max-width: 500px) {
  #ejimg1{
    display: none;
  }
  #ejimg2{
    display: block;
    width: 100%;
  }
  .tabbox {
    padding: 0px 15px 0 15px !important;
    margin-left: -10px !important;
    max-height: 200px;
    overflow: auto;
  }
  .tabbox div {
    margin-left: 10px;
  }
  .yzxckdk{
    padding-left: 12% !important;
  }
  .content{
    min-height: 500px;
    display: block;
  }
  .sanjimulu{
    margin-right: 30px;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgb(110, 110, 110);
    border-right:none;
    max-width: 100%;
  }
  .tabbox div{
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    min-width: 80px;
    cursor: pointer;
    padding: 5px 2px;
    margin-left: 20px;
    text-align:inherit!important;
    width: calc(100%/4 - 50px)!important;
  }
}
</style>
